/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from "./vuetify";
import { createPinia } from "pinia";
import createAppRouter from '@/router';
import VueCookies from "vue-cookies";

// Types
import type { App } from "vue";
import initI18n from "./i18n";
import type { IApp } from "@/types/app";

export function registerPlugins (app: App) {
  app.use(VueCookies, { expires: "30d", secure: true })
  app
    .use(createPinia())
    .use(vuetify)
    .use(createAppRouter())
    .use(initI18n(app as IApp));
}
